<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Nome</th>
        <th scope="col" class="border-0">E-mail</th>
        <th scope="col" class="border-0">Função</th>
        <th scope="col" class="border-0">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in users" :key="index">
        <td class="td-1">{{ row.id }}</td>
        <td class="td-4 link">
          <router-link
            :to="{ name: 'admin-user-edit', params: { userId: row.id }}"
          >
            {{ row.name }}
          </router-link>
        </td>
        <td class="td-3">{{ row.email }}</td>
        <td class="td-2">{{ (row.settings.role.name) ? row.settings.role.name : 'Administrador' }}</td>
        <td class="td-2">
          <user-buttons :user="row"></user-buttons>
        </td>
      </tr>
      <tr v-if="users.length === 0">
        <td colspan="7" class="no-content">Ainda não tem nenhum usuário cadastrado.</td>
      </tr>
    </tbody>
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão de usuário"
      message="Tem certeza que deseja excluir esse usuário?"/>
  </table>
</template>

<script>
import Events from '_utils/events';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import UserButtons from './UserButtons.vue';
import UserDelete from './UserDelete';
import { _DELETE_USER_ } from './UserModel';

export default {
  name: 'user-table',
  mixins: [UserDelete],
  components: {
    UserButtons,
    ConfirmationModal,
  },
  props: {
    users: {
      type: Array,
    },
  },
  data() {
    return {
      selectUser: null,
    };
  },
  mounted() {
    Events.$on(_DELETE_USER_, user => {
      this.selectUser = user.id;
    });
  },
  destroyed() {
    Events.$off(_DELETE_USER_);
  }
};
</script>
